import * as React from 'react';
import styled from "styled-components";
import Dropzone, {FileWithPreview} from "react-dropzone";
import HeadlineLarge from "../text/headline_large";
import {ConstColor} from "../../../../config/styles_const/styles_const";
import Paragraph from "../text/paragraph";
import AvatarLarge from "../avatar/avatar_large";
import {frontEndConfig} from "../../../../config/config";

const uploadFileMaxSize = frontEndConfig.uploadFileMaxSize;

interface IProps {
    name: string
    handleOnDrop: (acceptedFiles: FileWithPreview[], rejectedFiles: FileWithPreview[]) => void;
    updateIconURL: string | null;
    iconURL: string;
}

const StyledAvatarDropZone: React.FC<IProps> = (props) => {

    const {name, handleOnDrop, updateIconURL, iconURL} = props;

    return(
        <StyledDropZoneDefalt
            name={name}
            onDrop={handleOnDrop}
            accept="image/jpeg, image/png"
            disablePreview={false}
            multiple={false}
            maxSize={uploadFileMaxSize}
        >
            <DropZoneTxtWrapper>
                <DropZoneICon icon='"\f030"'/>
                <DropZoneTxt >変更する</DropZoneTxt>
            </DropZoneTxtWrapper>
            {(updateIconURL) ? (
                <div>
                    <AvatarLarge key={updateIconURL} src={updateIconURL}/>
                </div>) : (
                <div>
                    <AvatarLarge key={iconURL}
                                 src={iconURL}
                    />
                </div>)
            }
        </StyledDropZoneDefalt>
    )
};

export default StyledAvatarDropZone

const StyledDropZoneDefalt = styled(Dropzone)`
    position: relative;
    height: 180px;
    width: 180px;
    margin: 40px auto 35px auto;
    &:hover {
        cursor: pointer;
    }
`;

const DropZoneTxtWrapper = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin:0;
    padding:0;
    text-align: center;
`;

const DropZoneICon = styled(HeadlineLarge)`
    color: ${ConstColor.Corporate};
    &:before {
        margin-right: 0;
    }
`;

const DropZoneTxt = styled(Paragraph)`
    color: ${ConstColor.Corporate};
`;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/drop_zone/styled_avatar_drop_zone.tsx